/* eslint-disable react-hooks/exhaustive-deps */
import { useState, memo, useEffect } from "react";
import { Helmet } from "react-helmet";

import Content from "./components/content/content.component";
import SideBar from "./components/sideBar/sideBar.component";
import Header from "./components/header/header.component";

import useAuthData from "../hook/useAppData";
import "./layout.component.scss";
import logo from "../image/logoWithoutName.svg";
import { getProfiles } from "../module/Profile/service";
import Button from "../components/Button";
import { Link, useHistory } from "react-router-dom";
import { IconError } from "../icons";

interface LayoutProps {
  title: string;
  children?: any;
}

function LayoutComponent(props: LayoutProps) {
  const { token, profileId, contractType, statusCorporation, corporationCreatedBy, userId } = useAuthData();
  const [user, setUser] = useState("Administrador");
  const [closed, setClosed] = useState(closedSideBar());
  const history = useHistory();
  const planOk = statusCorporation?.planOk;

  function closedSideBar() {
    if (contractType === "CLT" && profileId === 3) return true;
    else return window.screen.width < 640 ? true : false;
  }

  useEffect(() => {
    getProfiles(token).then((data) => {
      data?.forEach((element: any) => {
        if (element.id === profileId) setUser(element.name);
      });
    });
  }, []);

  const errorRestriction = () => {
    if (history.location.pathname === "/payments" || history.location.pathname === "/payments-status" || planOk) return true;
    return false;
  };
  const userPayment = userId === corporationCreatedBy;

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <meta http-equiv="Content-Security-Policy" content="upgrade-insecure-requests" />
        <link rel="icon" href={logo} />
        <title>IntegraAdmin</title>
      </Helmet>
      <div className={`layoutContainer`}>
        <SideBar status={closed} />

        <div className={`contentContainer`}>
          <Header setClosed={setClosed} title={user} />
          <Content>
            {errorRestriction() ? (
              <>{props.children}</>
            ) : (
              <>
                <div className="absolute restriction-access z-50 flex justify-end items-end">
                  <div className="fixed flex flex-col justify-center w-3/5 h-36 bg-white rounded-lg m-20 mr-10 shadow-2xl">
                    <span className="absolute bg-red-700 h-full w-4 rounded-l-lg"> </span>
                    <div className="ml-2 p-4 flex flex-row justify-between">
                      <div className="flex flex-row items-center gap-3">
                        <span className="ml-5 flex items-center">{IconError}</span>
                        {userPayment ? (
                          <div>
                            <p className="text-3xl font-semibold">Atualizar forma de pagamento</p>
                            <p className="text-2xl">Não foi possível processar seu pagamento. Favor verificar clicando no botão ao lado</p>
                          </div>
                        ) : (
                          <div>
                            <p className="text-3xl font-semibold">Licença está expirada</p>
                            <p className="text-2xl">Entre em contato com seu administrador</p>
                          </div>
                        )}
                      </div>
                      {userPayment && (
                        <Link to="/payments">
                          <Button className="bg-primary mt-3 w-72 text-2xl">Ir para Pagamentos</Button>
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
                {props.children}
              </>
            )}
          </Content>
        </div>
      </div>
    </>
  );
}

export default memo(LayoutComponent);
